// ✅ src/data/teamData.js

import rajeev from "../assets/team/rajeev.png";
import adv from "../assets/team/adv.jpg";
import deepak from "../assets/team/deepak.png";
import shefali from "../assets/team/shefali.png";
import ashish from "../assets/team/ashish.png";
import anil from "../assets/team/anil.png";
import rohit from "../assets/team/rohit.png";

export const leaders = [
  {
    id: 1,
    name: "Rajeev Chhikara",
    role: "Founder, CEO",
    image: rajeev,
    linkedin: "https://www.linkedin.com/in/rajeevchhikara/",
  },
  {
    id: 2,
    name: "A D Vashishta",
    role: "Growth Partner",
    image: adv,
    linkedin: "https://www.linkedin.com/in/advashishta/",
  },
];

export const advisoryBoard = [
  {
    id: 1,
    name: "Anil Mehta",
    role: "Strategic Advisor",
    image: anil,
    linkedin: "#",
  },
  {
    id: 2,
    name: "Rohit Kumar",
    role: "Technical Advisor",
    image: rohit,
    linkedin: "#",
  },
];
